import { processEnv } from '../../env.mjs';

export const languages: string[] = processEnv.NEXT_PUBLIC_LANGUAGES.split(
    ','
).map((x) => x.trim());
export const defLanguage = processEnv.NEXT_PUBLIC_DEFAULT_LANGUAGE;